import { ProductGroup } from "ProductGrid/types";

const buildStateKeyForProduct = (product: ProductGroup) =>
  `${product.styleId}:${product.colorId}`;

export default buildStateKeyForProduct;
